import React, { useEffect, useState } from "react";
import styles from "./styles/Spinner.module.css";
/**
 *Spinner component
 */

const Spinner = ({ small, button }) => {
    return (
        <div
            className={`${styles.spinner_container} ${
                button ? styles.button_container : ""
            } flex-container`}
        >
            <div
                style={{ boarderColer: "#0023FF" }}
                className={`${button ? styles.loader_button : styles.loader} ${
                    small ? styles.small : ""
                } ${button ? styles.button_spinner : ""}`}
            ></div>
        </div>
    );
};

export default Spinner;
